'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Modules


var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _immutable = require('immutable');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _products = require('ifeis-isomorphic/lib/redux/actions//products');

var productActions = _interopRequireWildcard(_products);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _immutables = require('../../../../../immutables');

var _immutables2 = _interopRequireDefault(_immutables);

var _common = require('../../../../../common/common.module');

var _common2 = _interopRequireDefault(_common);

var _index = require('../../../../../product-list/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductsController = exports.ProductsController = function () {
  function ProductsController($scope, feis, $mdMedia) {
    _classCallCheck(this, ProductsController);

    this.svc = {
      $scope: $scope,
      $mdMedia: $mdMedia
    };
    this.feis = (0, _immutable.fromJS)(feis);
    this.viewStyle = 'grid';

    this.activate();
  }

  _createClass(ProductsController, [{
    key: 'activate',
    value: function activate() {
      var _this = this;

      this.svc.$scope.$watch(function () {
        return _this.svc.$mdMedia('xs');
      }, function (small) {
        _this.viewStyle = small ? 'list' : 'grid';
      });
    }
  }]);

  return ProductsController;
}();

exports.default = _angular2.default.module('ifeis.routes.feiseanna.one.admin.products', ['ui.router', 'ngMaterial', 'ifeis.immutables', 'ifeis.common', 'ifeis.product-list']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.products', {
    url: '/products',
    controller: ProductsController,
    controllerAs: '$ctrl',
    template: require('./tpl.html'),
    ncyBreadcrumb: {
      label: 'Products',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/products/index.js
// module id = 552
// module chunks = 0